// Standalone "quiz" onboarding funnel (mirrors the JumpSpeak quiz end-to-end),
// built on the existing light-themed onboarding components. It starts with the
// Flow landing page and then runs a sequence of quiz questions/interstitials
// before handing off to the shared sign-up flow. This funnel is completely
// independent of the /onboarding A/B wiring.

import navigateToNextQuizOnboardingPageAction from '@/actions/navigateToNextQuizOnboardingPageAction'
import FlowLandingPage from '@/pages/flow/FlowLandingPage'
import skipOnboardingLoader from '@app-studio-web/ui/loaders/skipOnboardingLoader'
import { Outlet } from 'react-router-dom'
import AgePage from './AgePage'
import ComparisonPage from './ComparisonPage'
import CurrentLevelPage from './CurrentLevelPage'
import DailyGoalPage from './DailyGoalPage'
import DesiredLevelPage from './DesiredLevelPage'
import GenderPage from './GenderPage'
import HowLongWantedPage from './HowLongWantedPage'
import ImportantEventPage from './ImportantEventPage'
import LearnerProfilePage from './LearnerProfilePage'
import MotivationPage from './MotivationPage'
import NervousnessPage from './NervousnessPage'
import PlanPreviewPage from './PlanPreviewPage'
import PreviewPage from './PreviewPage'
import QuizCraftingProgressPage from './QuizCraftingProgressPage'
import QuizLanguagePage from './QuizLanguagePage'
import SituationsPage from './SituationsPage'
import SkillFocusPage from './SkillFocusPage'
import StrugglePage from './StrugglePage'
import TestimonialPage from './TestimonialPage'
import TimeCommitmentPage from './TimeCommitmentPage'
import TopicsPage from './TopicsPage'
import TriedBeforePage from './TriedBeforePage'
import WhatWouldChangePage from './WhatWouldChangePage'

const quizOnboardingRoutes = [
  {
    path: '',
    element: <Outlet />,
    loader: skipOnboardingLoader,
    children: [
      // Entry: the Flow landing page owns the ad-entry URL and sends its CTA
      // straight to the first question (age); no action here.
      {
        element: <FlowLandingPage startPath="/quiz/age" />,
        path: 'question-language',
      },
      {
        action: navigateToNextQuizOnboardingPageAction,
        element: <AgePage />,
        path: 'age',
      },
      {
        action: navigateToNextQuizOnboardingPageAction,
        element: <GenderPage />,
        path: 'gender',
      },
      {
        action: navigateToNextQuizOnboardingPageAction,
        element: <QuizLanguagePage />,
        path: 'language',
      },
      {
        action: navigateToNextQuizOnboardingPageAction,
        element: <MotivationPage />,
        path: 'motivation',
      },
      {
        action: navigateToNextQuizOnboardingPageAction,
        element: <StrugglePage />,
        path: 'struggle',
      },
      {
        action: navigateToNextQuizOnboardingPageAction,
        element: <NervousnessPage />,
        path: 'nervousness',
      },
      {
        action: navigateToNextQuizOnboardingPageAction,
        element: <PreviewPage />,
        path: 'preview',
      },
      {
        action: navigateToNextQuizOnboardingPageAction,
        element: <SituationsPage />,
        path: 'situations',
      },
      {
        action: navigateToNextQuizOnboardingPageAction,
        element: <WhatWouldChangePage />,
        path: 'what-would-change',
      },
      {
        action: navigateToNextQuizOnboardingPageAction,
        element: <HowLongWantedPage />,
        path: 'how-long-wanted',
      },
      {
        action: navigateToNextQuizOnboardingPageAction,
        element: <TriedBeforePage />,
        path: 'tried-before',
      },
      {
        action: navigateToNextQuizOnboardingPageAction,
        element: <ComparisonPage />,
        path: 'comparison',
      },
      {
        action: navigateToNextQuizOnboardingPageAction,
        element: <CurrentLevelPage />,
        path: 'current-level',
      },
      {
        action: navigateToNextQuizOnboardingPageAction,
        element: <DesiredLevelPage />,
        path: 'desired-level',
      },
      {
        action: navigateToNextQuizOnboardingPageAction,
        element: <TimeCommitmentPage />,
        path: 'time-commitment',
      },
      {
        action: navigateToNextQuizOnboardingPageAction,
        element: <DailyGoalPage />,
        path: 'daily-goal',
      },
      {
        action: navigateToNextQuizOnboardingPageAction,
        element: <TestimonialPage />,
        path: 'testimonial',
      },
      {
        action: navigateToNextQuizOnboardingPageAction,
        element: <SkillFocusPage />,
        path: 'skill-focus',
      },
      {
        action: navigateToNextQuizOnboardingPageAction,
        element: <TopicsPage />,
        path: 'topics',
      },
      {
        action: navigateToNextQuizOnboardingPageAction,
        element: <ImportantEventPage />,
        path: 'important-event',
      },
      {
        action: navigateToNextQuizOnboardingPageAction,
        element: <LearnerProfilePage />,
        path: 'learner-profile',
      },
      {
        action: navigateToNextQuizOnboardingPageAction,
        element: <PlanPreviewPage />,
        path: 'plan-preview',
      },
      // Last step: auto-advances, and being last the action redirects to
      // /sign-up/company.
      {
        action: navigateToNextQuizOnboardingPageAction,
        element: <QuizCraftingProgressPage />,
        path: 'crafting-progress',
      },
    ],
  },
]

export default quizOnboardingRoutes
